import type React from 'react';

// Styles
import { SelectInput } from '../../styled/components/sign-up';

import type { PaymentMethodInfo } from '@avalara/types/index';

type Props = {
  paymentMethodSelectionInfo: PaymentMethodInfo;
  onSetPaymentMethod: (paymentMethodId: string | null) => void;
};

export const newPaymentMethodWording = 'Add new payment method';

const PaymentMethodSelector = (props: Props) => {
  const { selectedPaymentMethodId, fieldValues } = props.paymentMethodSelectionInfo;
  return (
    <fieldset data-ref='buy.payment.fieldset'>
      <SelectInput
        name='payment'
        defaultValue={selectedPaymentMethodId || ''}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
          props.onSetPaymentMethod(e.target.value);
        }}
      >
        {fieldValues.map((field) => (
          <option key={`${field.paymentMethod.Id}`} value={field.paymentMethod.Id}>
            {field.wording}
          </option>
        ))}
        <option>{newPaymentMethodWording}</option>
      </SelectInput>
    </fieldset>
  );
};

export default PaymentMethodSelector;
